import { render, staticRenderFns } from "./MintEntitiesSummary.vue?vue&type=template&id=0655ac40&"
import script from "./MintEntitiesSummary.vue?vue&type=script&lang=js&"
export * from "./MintEntitiesSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports